
import {  generateCellRequestMessage } from './notebook';
import { NOTEBOOK_WS_CONNECTOR_URL } from '../../../settings/shared/constants';
 
/**
 * 
 * @param {*} connectionId 
 */
export const establishWSConnection = (connectionId) => {
    // let URL = 'ws://localhost:8888/api/kernels/5b4bbb17-dd79-4945-b2fe-9bf20c7f8152/channels'
    // connectionId = '608cba0138e6d57db665c913';
    let URL = NOTEBOOK_WS_CONNECTOR_URL + connectionId
    var aWebSocket = new WebSocket(URL);
    return aWebSocket;
}

/**
 * 
 * @param {*} ws  
 * @param {*} cell_id 
 * @param {*} code_cell 
 * @param {*} cell_index 
 * @param {*} notebook_content 
 * @param {*} isSingleCell //Single cell or all notebook cell
 */
export const executeCode = (ws, code_cell, metadata, index, filePath, fileType, isSingleCell) => {
    if (ws !== undefined) {
        if (code_cell !== undefined) {
            let source = parseCodeCellSource(code_cell.source)
            if(source.length > 0) {
                let cell_id = code_cell.metadata.decisionforce_cell_id;
                let request = generateCellRequestMessage(source, metadata, cell_id, index, filePath, fileType, isSingleCell);
                
                try {
                    ws.send(JSON.stringify(request));
                } catch(err) {
                    // console.log('Connection error!!! ');
                }
               
            }  
        }
    }
}



/**
 * 
 * @param {*} response 
 * @param {*} cell 
 * @param {*} index 
 */
export const parseWebsocketReply = (response, cell, index) => {
    
    if(response !== undefined) {
        let json_data = JSON.parse(response)
        let header = json_data.header;
        let parent_header = json_data.parent_header;
        let content = json_data.content;
        
        if(header !== undefined) {
            let decisionforce_cell_id = parent_header.decisionforce_cell_id;
            let file_path = parent_header.file_path;
            let file_type = parent_header.file_type;
            let is_single_cell = parent_header.is_single_cell;
            let notebook_metadata = parent_header.notebook_metadata;
            let current_cell_index = parent_header.current_index
            let msg_type = header.msg_type;
            
            
            if(msg_type === 'status') {
                if (content !== undefined) {
                    let execution_state = content.execution_state;
                    let result = {
                        'output_type' : msg_type,
                        'decisionforce_cell_id' : decisionforce_cell_id,
                         'current_cell_index' : current_cell_index,
                         'state' : execution_state
                    }
                    return result;
                }          
            } else if ((msg_type === 'execute_input') || (msg_type === 'execute_reply')) {
                if(content !== undefined) {
                    let execution_state = content.status;
                    let execution_count = content.execution_count;
                    
                    let result = {
                        'output_type' : msg_type,
                        'decisionforce_cell_id' : decisionforce_cell_id,
                        'current_cell_index' : current_cell_index,
                        'execution_count' : execution_count,
                        'notebook_metadata' : notebook_metadata,
                        'state' : execution_state,
                        'file_path' : file_path,
                        'file_type' : file_type,
                        'is_single_cell' : is_single_cell
                    }
                    return result;
                }
            } else if(msg_type === 'stream') {
                
                if(content !== undefined) {
                    let outputs = []
                    let outputCell = cell.outputs;

                    let outputElement = {
                        'output_type' : msg_type
                    }
                    if ((outputCell !== undefined) && (outputCell.length > 0)) {
                        outputCell.forEach(element => {
                            
                            let name = element.name; //stdout or stderr
                            let textArray = element.text;      
                            
                            if((textArray === undefined) || (!Array.isArray(textArray))) {
                                textArray = []
                             }
                            if(name === undefined) {
                                name = content.name
                                textArray.push(content.text)
                            } else if (name === content.name) {
                                textArray.push(content.text)
                            }
                            
                            var value = "MB/s eta"
                            var outputValue = "..."
                            var n = textArray.findIndex(element => element.includes(value));
                            if(n => 0) {
                                textArray[n] = outputValue;
                            }

                            outputElement['name'] = name;
                            outputElement['text'] = textArray;
                            outputs.push(outputElement);
                        });
                    } else {
                        let textArray = [];
                        textArray.push(content.text);
                        outputElement['name'] = content.name;
                        outputElement['text'] = textArray;
                        outputs.push(outputElement);
                    }
                    let result = {
                        'output_type' : msg_type,
                        'notebook_metadata' : notebook_metadata,
                        'decisionforce_cell_id' : decisionforce_cell_id,
                        'current_cell_index' : current_cell_index,
                        'file_path' : file_path,
                        'file_type' : file_type,
                        'outputs' : outputs,
                    }
                    return result;
                }  
                
            } else if ((msg_type === 'display_data') || (msg_type === 'execute_result')) {
                if(content !== undefined) {
                    let outputCell = cell.outputs;
                    let text_plain = content.data['text/plain'];
                    let img_png = content.data['image/png'];
                    let text_html = content.data['text/html'];
                    let metadata = content.metadata;
                    
                    let outputElement = {}
                    if(text_plain !== undefined) {
                        let text = [];
                        text.push(text_plain);
                        outputElement['text/plain'] = text;
                    }
                    if(img_png !== undefined) {
                        outputElement['image/png'] = img_png;
                    }

                    if(metadata !== undefined) {
                        outputElement['metadata'] = metadata;
                    }

                    if(text_html !== undefined) {
                        outputElement['text/html'] = text_html;
                    }

                    if ((outputCell === undefined) || (!Array.isArray(outputCell))) {
                        outputCell = [];
                    }   

                    let data = {
                        'output_type' : msg_type,
                        'data' : outputElement
                    }

                    outputCell.push(data)
                    let result = {
                        'output_type' : msg_type,
                        'notebook_metadata' : notebook_metadata,
                        'decisionforce_cell_id' : decisionforce_cell_id,
                        'current_cell_index' : current_cell_index,
                        'file_path' : file_path,
                        'file_type' : file_type,
                        'outputs' : outputCell
                    }
                    return result;
                }
            } else if(msg_type === 'error') {
                if(content !== undefined) {
                    let outputs = [];
                    let ename = content.ename;
                    let evalue = content.evalue;
                    let traceback = content.traceback;

                    let output = {
                        'output_type':msg_type, 
                        'ename' : ename,
                        'evalue': evalue,
                        'traceback' :traceback
                    }
                    outputs.push(output);

                    let result = {
                        'output_type' : msg_type,
                        'notebook_metadata' : notebook_metadata,
                        'decisionforce_cell_id' : decisionforce_cell_id,
                        'current_cell_index' : current_cell_index,
                        'file_path' : file_path,
                        'file_type' : file_type,
                        'outputs' : outputs
                    }
                    return result;
                }              
            }
        }
    }
}


/**
 * Convert source array to string
 * @param {String Array} source 
 */
function parseCodeCellSource(source) {
    let request_code = '';
    if(Array.isArray(source)) {
        if(source !== undefined) {
            source.forEach(element => {
                request_code += element
                request_code += '\n'
            });
        }
    } else {
        request_code = source;
    }
    
    return request_code;
}